<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import Confirmation from '@/components/widgets/modals/Confirmation'
import CalibrateVolume from './Fuel/CalibrateVolume'
import { Helper } from '@/mixin/helper'
import { getToolsClient } from '@/services/tools'
import { getSmsClient } from '@/services/sms'
import Swal from 'sweetalert2'

const smsAxios = getSmsClient()
const toolsAxios = getToolsClient()

export default {
  components: { Confirmation, CalibrateVolume },

  mixins: [Helper, validationMixin],

  props: {
    modal: {
      type: Boolean,
      default: false,
    },
    sensor: {
      type: Object,
      default: () => {},
    },
    vehicles: {
      type: Array,
      default: () => [],
    },
    deviceCode: {
      type: Number,
      default: null,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    region: {
      type: String,
      default: 'SG',
    },
  },

  data() {
    return {
      isDisableSubmit: true,
      isHideTreshold: true,
      skipStatusFloat: true,
      form: {
        rangeHigh: null,
        rangeLow: null,
        alertLow: null,
        alertHigh: null,
        analog: false,
        fuelCapacity: null,
        statusFloat: null,
      },
      oldForm: {
        rangeHigh: null,
        rangeLow: null,
        alertLow: null,
        alertHigh: null,
        analog: false,
        fuelCapacity: null,
        statusFloat: null,
      },
      pinName: null,
      sensorName: null,
      sensorCode: null,
      dataSensor: [],
      pinCode: 0,
      modalConfirm: false,
      sensors: [],
      sensorTypes: [],
      activeTab: 0,
      optSensorCodeList: [],
      fuelCalibration: [],
    }
  },

  validations: {
    form: {
      rangeHigh: {
        required,
        minValue(val) {
          // Jika sensorCode adalah 32, maka rangeHigh harus lebih kecil dari rangeLow
          if (this.sensorCode === 32) {
            return true
          }
          // Untuk sensorCode lainnya, rangeHigh harus lebih besar dari rangeLow
          return parseFloat(val) > parseFloat(this.form.rangeLow) || 0
        },
      },
      rangeLow: {
        required,
        maxValue(val) {
          // Jika sensorCode adalah 32, maka rangeLow harus lebih besar dari rangeHigh
          if (this.sensorCode === 32) {
            return true
          }
          // Untuk sensorCode lainnya, rangeLow harus lebih kecil dari rangeHigh
          return parseFloat(val) < parseFloat(this.form.rangeHigh)
        },
      },
      statusFloat: {
        required(val) {
          if (this.skipStatusFloat) {
            return true
          } else {
            if (!val) {
              return false
            } else {
              return true
            }
          }
        },
        minValue(val) {
          if (this.skipStatusFloat) return true
          return parseFloat(val) > 0
        },
        maxValue(val) {
          if (this.skipStatusFloat) return true
          return parseFloat(val) <= 100
        },
      },
      alertLow: {
        required,
        maxValue(val, { alertHigh }) {
          return parseFloat(val) < parseFloat(alertHigh)
        },
      },
      fuelCapacity: {
        required,
        minValue(val) {
          return parseFloat(val) > parseFloat(0)
        },
      },
      alertHigh: {
        required,
        minValue(val, { alertLow }) {
          return parseFloat(val) > parseFloat(alertLow) || 0
        },
      },
    },
  },

  async created() {
    await this.getFuelOptions()

    // Ambil daftar sensor_code fuel yang valid dari pin-command
    const fuelSensorCodes = this.optSensorCodeList.map((s) => s.id)

    // Cari sensor fuel yang benar-benar terpasang & aktif di kendaraan ini
    const activeFuelSensor = this.sensor?.sensor_type?.find(
      (v) => fuelSensorCodes.includes(v.sensor_code) && v.pin_code > 0
    )

    if (activeFuelSensor) {
      this.sensorCode = activeFuelSensor.sensor_code
      this.pinCode = activeFuelSensor.pin_code
      await this.handleSensorTypeChange()
    } else {
      this.clearForm()
      this.isDisableSubmit = true
      this.getSensors()
    }
  },

  computed: {
    showModal: {
      get() {
        return this.modal
      },
      set(newVal) {
        this.$emit('update:modal', newVal)
      },
    },
    loading: {
      get() {
        return this.isLoading
      },
      set(newVal) {
        this.$emit('update:isLoading', newVal)
      },
    },
    vehicleFields() {
      if (this.show_model && this.show_model.length > 0) {
        const result = this.show_model.map((a) => a.key)
        return this.vehicleField.filter(function (item) {
          return item.key == 'check' || result.includes(item.key)
        })
      } else {
        return this.vehicleField
      }
    },
    vehicleField() {
      return [
        {
          key: 'last_data_raw',
          label: this.$t('vehicle.status.lastPacket'),
        },
        {
          key: 'fuel_raw',
          label: this.$t('vehicle.status.fuelRaw'),
        },
        {
          key: 'vehicle_status.fuel_filtered',
          label: this.$t('vehicle.status.fuelPercentage'),
        },
        {
          key: 'vehicle_status.latitude',
          label: this.$t('vehicle.status.latitude'),
        },
        {
          key: 'vehicle_status.longitude',
          label: this.$t('vehicle.status.longitude'),
        },
        {
          key: 'vehicle_status.engine_on',
          label: this.$t('vehicle.status.ignition'),
        },
        {
          key: 'vehicle_status.speed',
          label: this.$t('vehicle.status.speed'),
        },
      ]
    },
    sensorFields() {
      if (this.show_model && this.show_model.length > 0) {
        const result = this.show_model.map((a) => a.key)
        return this.sensorField.filter(function (item) {
          return item.key == 'check' || result.includes(item.key)
        })
      } else {
        return this.sensorField
      }
    },
    sensorField() {
      return [
        {
          key: 'vehicle.imei',
          label: this.$t('task.column.imei'),
        },
        {
          key: 'vehicle.license_plate',
          label: this.$t('master.form.fleet.licensePlate'),
        },
        {
          key: 'range_hi',
          label: this.$t('sensor.rangeHigh'),
        },
        {
          key: 'range_lo',
          label: this.$t('sensor.rangeLow'),
        },
        {
          key: 'alert_hi',
          label: this.$t('sensor.alertHigh'),
        },
        {
          key: 'alert_lo',
          label: this.$t('sensor.alertLow'),
        },
        {
          key: 'fuel_capacity',
          label: this.$t('sensor.fuelCapacity'),
        },
        {
          key: 'require_engine',
          label: this.$t('sensor.analog'),
        },
        {
          key: 'status_float',
          label: this.$t('sensor.statusFloat'),
        },
        {
          key: 'edited_at',
          label: this.$t('sensor.editedAt'),
        },
        {
          key: 'edited_by',
          label: this.$t('sensor.editedBy'),
        },
      ]
    },
  },

  methods: {
    mapSensorName(sensor_code) {
      return this.sensorTypes?.find((e) => e.sensor_code === sensor_code)?.sensor_name
    },

    isFuel(command) {
      // Check if the command contains the word "fuel" (case insensitive)
      return command?.toLowerCase().includes('fuel') || false
    },

    async mapDataSensorFromPinCommand() {
      let params = {
        filters: `deviceCode:eq:${this.deviceCode}`,
      }
      let mappedData = {}
      let arrData = []
      const dataSensor = await smsAxios.get(`/pin-command`, { params })
      dataSensor.data?.forEach((data) => {
        const sensor_name = this.mapSensorName(data.sensor_code)

        if (!this.isFuel(data.command)) {
          return
        }

        if (!mappedData[`${data.sensor_code}`]) {
          mappedData[`${data.sensor_code}`] = data
          mappedData[`${data.sensor_code}`]['sensor_name'] = sensor_name
        }
      })
      Object.keys(mappedData).forEach((data) => {
        arrData.push({
          id: Number(data),
          name: mappedData[data]['sensor_name'],
        })
      })

      this.optSensorCodeList = arrData
    },

    async getFuelOptions() {
      try {
        await toolsAxios
          .get('sensor-type', {
            headers: {
              'X-Region': this.region,
            },
          })
          .then((res) => (this.sensorTypes = res.data))
      } catch (error) {
        this.handleError(error)
      }

      await this.mapDataSensorFromPinCommand()
    },

    mapSensorToForm(sensor) {
      const fields = {
        rangeHigh: 'range_hi',
        rangeLow: 'range_lo',
        alertLow: 'alert_lo',
        alertHigh: 'alert_hi',
        analog: 'require_engine',
        fuelCapacity: 'fuel_capacity',
        statusFloat: 'status_float',
      }

      Object.entries(fields).forEach(([formKey, sensorKey]) => {
        this.form[formKey] = sensor[sensorKey]
        this.oldForm[formKey] = sensor[sensorKey]
      })

      this.pinCode = sensor.pin_code
      this.sensorCode = sensor.sensor_code
      this.sensorName = sensor.sensor_name
      this.pinName = sensor.pin_name
    },

    // Clear form fields
    clearForm() {
      this.form = {
        rangeHigh: null,
        rangeLow: null,
        alertLow: null,
        alertHigh: null,
        analog: null,
        fuelCapacity: null,
        statusFloat: null,
      }
      this.oldForm = { ...this.form }
      this.pinCode = null
      this.sensorName = null
      this.pinName = null
      this.sensorCode = null
    },

    async handleSensorTypeChange() {
      this.loading = true
      const sensor_type = this.sensor.sensor_type.find((v) => v.sensor_code == this.sensorCode)

      if (sensor_type) {
        this.mapSensorToForm(sensor_type)
        this.isDisableSubmit = false
      } else {
        this.$toast.error(this.$t('error.sensorNotFound'))
        this.clearForm()
        this.isDisableSubmit = true
      }

      if (this.sensorCode == 32) {
        this.isHideTreshold = false
        this.skipStatusFloat = false
      } else {
        this.isHideTreshold = true
        this.skipStatusFloat = true
      }

      await this.getSensors()
      await this.getFuelCalibration()

      this.loading = false
    },

    tabActivated(newTabIndex, oldTabIndex, event) {
      if (!this.checkValidation()) {
        this.showValidationErrorModal()
        event.preventDefault()
      }
    },

    showValidationErrorModal() {
      // Use SweetAlert or any other modal library to display an error message
      Swal.fire({
        title: 'Validation Error',
        text: 'Please complete the required fields before switching tabs.',
        icon: 'error',
        confirmButtonText: 'OK',
      })
    },

    checkValidation() {
      this.$v.form.$touch()
      if (this.$v.form.$error) {
        this.$v.form.$reset()
        return false
      }
      return true
    },

    async handleSubmit(bvModalEvent) {
      if (this.activeTab === 0) {
        bvModalEvent.preventDefault()
        this.$v.form.$touch()
        if (this.$v.form.$error) {
          return
        }
        this.modalConfirm = true
      } else if (this.activeTab === 1) {
        if (!this.$refs.volumeCalibrateRef.isValid) {
          this.loading = true
          await this.$nextTick()
          this.$toast.error(this.$t('global.failed.save'))
          this.loading = false

          return
        }
        const payload = {
          vehicleId: this.vehicles[0].vehicle_id,
          sensorType: this.sensorCode,
          vehicleFuelCalibrationList: this.$refs.volumeCalibrateRef.fuelCalibration,
        }
        const response = await toolsAxios
          .post('/vehicle/fuel-calibration', payload, {
            headers: {
              'X-Region': this.region, // Tambahkan header di sini
            },
          })
          .catch((error) => {
            this.handleError(error)
          })
        if (!response?.data) {
          return
        }
        this.loading = true
        await this.$nextTick()
        this.$toast.success(this.$t('global.success.save'))
        this.loading = false
      }
    },

    afterConfirm() {
      const payload = {
        sensor_code: this.sensorCode,
        pin_code: this.pinCode,
        range_lo: parseFloat(this.form.rangeLow),
        range_hi: parseFloat(this.form.rangeHigh),
        alert_lo: parseFloat(this.form.alertLow),
        alert_hi: parseFloat(this.form.alertHigh),
        old_pin_code: this.pinCode,
        require_engine: this.form.analog,
        fuel_capacity: parseFloat(this.form.fuelCapacity),
        status_float: parseFloat(this.form.statusFloat),
      }
      if (this.pinCode === 0) {
        this.$toast.error('Sensor Fuel masih disable')
      } else {
        this.$emit('beforeSubmit', { payload, overwrite: true })
      }
    },

    async getSensors() {
      const queryParameters = {
        includes: 'vehicle:left:vehicleId',
        filters: `vehicle:licensePlate:eq:${this.vehicles[0].license_plate};sensorType:sensorCode:eq:${this.sensorCode}`,
        page: 1,
        size: 1,
      }
      const sensors = await toolsAxios
        .get('/sensor', {
          params: queryParameters,
          headers: {
            'X-Region': this.region,
          },
        })
        .catch((error) => {
          this.handleError(error)
        })
      if (!sensors?.data?.data) return
      this.sensors = sensors.data.data

      if (this.sensors.length > 0) {
        this.sensors[0].fuel_capacity = this.vehicles[0].vehicle_status?.fuel_capacity
      }
    },

    handleError(error) {
      if (error.response) {
        this.$toast.error(error.response.data.error)
      } else if (error.request) {
        this.$toast.error(error.response.statusText)
      } else {
        this.$toast.error(error.message)
      }
      return
    },

    getFuelCalibrationBySensorCode(fuelCalibration, sensorCode) {
      return fuelCalibration.filter((item) => item.sensor_type === sensorCode)
    },

    async getFuelCalibration() {
      const vehicleFuelCalibrationList = await toolsAxios
        .get('/vehicle/fuel-calibration/' + this.vehicles[0].vehicle_id.toString(), {
          headers: {
            'X-Region': this.region,
          },
        })
        .catch((error) => {
          this.handleError(error)
        })

      if (!vehicleFuelCalibrationList?.data) {
        return
      }

      this.fuelCalibration = this.getFuelCalibrationBySensorCode(
        vehicleFuelCalibrationList.data,
        this.sensorCode
      )
    },
  },
}
</script>

<template>
  <div>
    <b-modal
      v-model="showModal"
      class="mc-modal"
      id="modal-form"
      title="Fuel Setting"
      size="lg"
      centered
      :hide-header-close="loading"
      no-close-on-backdrop
    >
      <b-tabs v-on:activate-tab="tabActivated" v-model="activeTab">
        <b-tab active class="border-0">
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="fas fa-home"></i>
            </span>
            <span class="d-none d-sm-inline-block">High Calibrate</span>
          </template>
          <div class="card-body mc-modal__filter p-2">
            <b-form @submit.stop.prevent="handleSubmit">
              <b-row>
                <b-col cols="6">
                  <label class="mt-3 required">{{ $t('sensor.type') }}</label>
                  <v-select
                    v-model="sensorCode"
                    :options="optSensorCodeList"
                    placeholder="Pilih sensor"
                    label="name"
                    :reduce="(v) => v.id"
                    @input="handleSensorTypeChange"
                  />
                </b-col>
                <b-col cols="6"> </b-col>
                <b-col cols="6">
                  <label class="mt-3"
                    >{{ $t('sensor.sensorName') }} : {{ sensorName ? sensorName : '-' }}</label
                  >
                </b-col>
                <b-col cols="6">
                  <label class="mt-3"
                    >{{ $t('sensor.pinName') }} : {{ pinName ? pinName : '-' }}</label
                  >
                </b-col>
                <b-col cols="6">
                  <label class="mt-3 required">{{ $t('sensor.rangeLow') }}</label>
                  <b-form-input
                    v-model.number="form.rangeLow"
                    @wheel.prevent
                    type="number"
                    :placeholder="$t('sensor.rangeLow')"
                    :class="{
                      'is-invalid': $v.form.rangeLow.$error,
                    }"
                  />
                  <div v-if="$v.form.rangeLow.$error" class="invalid-feedback">
                    <span v-if="!$v.form.rangeLow.required">{{ $t('sensor.required') }}</span>
                    <span v-else-if="!$v.form.rangeLow.maxValue">
                      <template v-if="sensorCode === 32">
                        {{ $t('sensor.valueMoreThan') + ' ' + $t('sensor.rangeHigh') }}
                      </template>
                      <template v-else>
                        {{ $t('sensor.valueLessThan') + ' ' + $t('sensor.rangeHigh') }}
                      </template>
                    </span>
                  </div>
                  <div
                    v-if="
                      sensorCode === 32 && parseFloat(form.rangeHigh) > parseFloat(form.rangeLow)
                    "
                    class="text-warning small mt-1"
                  >
                    <i class="fas fa-exclamation-triangle"></i>
                    {{ $t('sensor.valueMoreThan') + ' ' + $t('sensor.rangeHigh') }}
                  </div>
                </b-col>
                <b-col cols="6">
                  <label class="mt-3 required">{{ $t('sensor.alertLow') }}</label>
                  <b-form-input
                    v-model.number="form.alertLow"
                    @wheel.prevent
                    type="number"
                    :placeholder="$t('sensor.alertLow')"
                    :class="{
                      'is-invalid': $v.form.alertLow.$error,
                    }"
                  >
                  </b-form-input>
                  <div v-if="$v.form.alertLow.$error" class="invalid-feedback">
                    <span v-if="!$v.form.alertLow.required">{{ $t('sensor.required') }}</span>
                    <span v-else-if="!$v.form.alertLow.maxValue">
                      {{ $t('sensor.valueLessThan') + ' ' + $t('sensor.alertHigh') }}
                    </span>
                  </div>
                </b-col>
                <b-col cols="6">
                  <label class="mt-3 required">{{ $t('sensor.rangeHigh') }}</label>
                  <b-form-input
                    v-model.number="form.rangeHigh"
                    @wheel.prevent
                    type="number"
                    :placeholder="$t('sensor.rangeHigh')"
                    :class="{
                      'is-invalid': $v.form.rangeHigh.$error,
                    }"
                  >
                  </b-form-input>
                  <div v-if="$v.form.rangeHigh.$error" class="invalid-feedback">
                    <span v-if="!$v.form.rangeHigh.required">{{ $t('sensor.required') }}</span>
                    <span v-else-if="!$v.form.rangeHigh.minValue">
                      <template v-if="sensorCode === 32">
                        {{ $t('sensor.valueLessThan') + ' ' + $t('sensor.rangeLow') }}
                      </template>
                      <template v-else>
                        {{ $t('sensor.valueMoreThan') + ' ' + $t('sensor.rangeLow') }}
                      </template>
                    </span>
                  </div>
                  <div
                    v-if="
                      sensorCode === 32 && parseFloat(form.rangeLow) < parseFloat(form.rangeHigh)
                    "
                    class="text-warning small mt-1"
                  >
                    <i class="fas fa-exclamation-triangle"></i>
                    {{ $t('sensor.valueLessThan') + ' ' + $t('sensor.rangeLow') }}
                  </div>
                </b-col>
                <b-col cols="6">
                  <label class="mt-3 required">{{ $t('sensor.alertHigh') }}</label>
                  <b-form-input
                    v-model.number="form.alertHigh"
                    @wheel.prevent
                    type="number"
                    :placeholder="$t('sensor.alertHigh')"
                    :class="{
                      'is-invalid': $v.form.alertHigh.$error,
                    }"
                  >
                  </b-form-input>
                  <div v-if="$v.form.alertHigh.$error" class="invalid-feedback">
                    <span v-if="!$v.form.alertHigh.required">{{ $t('sensor.required') }}</span>
                    <span v-else-if="!$v.form.alertHigh.minValue">
                      {{ $t('sensor.valueMoreThan') + ' ' + $t('sensor.alertLow') }}
                    </span>
                  </div>
                </b-col>
                <b-col cols="6">
                  <label class="mt-3 required">{{ $t('sensor.fuelCapacity') }}</label>
                  <b-form-input
                    v-model.number="form.fuelCapacity"
                    @wheel.prevent
                    type="number"
                    :placeholder="$t('sensor.fuelCapacity')"
                    :class="{
                      'is-invalid': $v.form.fuelCapacity.$error,
                    }"
                  >
                  </b-form-input>
                  <div v-if="$v.form.fuelCapacity.$error" class="invalid-feedback">
                    <span v-if="!$v.form.fuelCapacity.required">{{ $t('sensor.required') }}</span>
                    <span v-else-if="!$v.form.fuelCapacity.minValue">
                      {{ $t('sensor.valueMoreThan') + ' 0' }}
                    </span>
                  </div>
                </b-col>
                <b-col cols="6">
                  <div v-if="!isHideTreshold">
                    <label class="mt-3 required">{{ $t('sensor.statusFloat') }}</label>
                    <b-form-input
                      v-model.number="form.statusFloat"
                      @wheel.prevent
                      type="number"
                      :placeholder="'Treshold Voltage / %'"
                      :class="{
                        'is-invalid': $v.form.statusFloat.$error,
                      }"
                    >
                    </b-form-input>
                    <div v-if="$v.form.statusFloat.$error" class="invalid-feedback">
                      <span v-if="!$v.form.statusFloat.required">{{ $t('sensor.required') }}</span>
                      <span v-else-if="!$v.form.statusFloat.maxValue">
                        {{ $t('sensor.valueLessThan') + ' 100' }}
                      </span>
                      <span v-else-if="!$v.form.statusFloat.minValue">
                        {{ $t('sensor.valueMoreThan') + ' 0' }}
                      </span>
                    </div>
                  </div>
                </b-col>
                <b-col cols="6">
                  <div class="mt-3 form-check-right form-switch">
                    <input
                      class="form-check-input ms-2"
                      type="checkbox"
                      id="moreinfo-history"
                      v-model="form.analog"
                    />
                    <span class="" for="moreinfo-history">{{ $t('sensor.fuelOdo') }}</span>
                  </div>
                </b-col>
              </b-row>
            </b-form>
            <br />
            <h5>{{ $t('vehicle.status.lastCheckData') }}</h5>
            <div class="table-responsive mb-0 my-3 border border-1">
              <b-table
                class="datatables"
                :items="vehicles"
                :fields="vehicleFields"
                show-empty
                :empty-text="$t('global.emptyTable')"
                :busy="loading"
              >
                <template #cell(last_data_raw)="data">
                  {{ data.item.last_data_raw ? momentDMHms(data.item.last_data_raw) : '-' }}
                </template>
                <template #cell(fuel_raw)="data">
                  {{ data.item.fuel_raw ? data.item.fuel_raw : '-' }}
                </template>
                <template #cell(vehicle_status.engine_on)="data">
                  {{ data.item.vehicle_status ? '' : '-' }}
                  <span
                    class="mc-status mc-status--green"
                    v-if="data.item.vehicle_status.engine_on"
                  >
                    {{ $t('global.on') }}
                  </span>
                  <span class="mc-status mc-status--red" v-else>
                    {{ $t('global.off') }}
                  </span>
                </template>
              </b-table>
            </div>
            <br />
            <h5>{{ $t('vehicle.status.lastSetData') }}</h5>
            <div class="table-responsive mb-0 my-3 border border-1">
              <b-table
                class="datatables"
                :items="sensors"
                :fields="sensorFields"
                show-empty
                :empty-text="$t('global.emptyTable')"
                :busy="loading"
              >
                <template #cell(edited_at)="data">
                  {{ data.item.edited_at ? momentDMHms(data.item.edited_at) : '-' }}
                </template>
              </b-table>
            </div>
          </div>
          <confirmation
            v-if="modalConfirm"
            :modal.sync="modalConfirm"
            message="Yakin ingin melakukan Pengaturan High Calibrate Fuel"
            @confirmed="afterConfirm"
          />
        </b-tab>
        <b-tab class="border-0">
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="fas fa-home"></i>
            </span>
            <span class="d-none d-sm-inline-block">Volume Calibrate</span>
          </template>
          <div style="min-height: 626px">
            <CalibrateVolume
              v-if="!loading"
              :vehicles="vehicles"
              :rangeLow="form.rangeLow"
              :rangeHigh="form.rangeHigh"
              :sensorCode="sensorCode"
              :fuelCalibration="fuelCalibration"
              :loading="loading"
              ref="volumeCalibrateRef"
            />
            <div v-else class="text-center text-primary my-4">
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </div>
        </b-tab>
      </b-tabs>
      <template #modal-footer="{ cancel }">
        <b-row class="mc-modal__filter-footer">
          <b-col cols="12" class="mc-modal__filter-footer-btn">
            <b-button variant="outline-primary" @click="cancel()" :disabled="loading" class="me-3">
              Batal
            </b-button>
            <b-button
              @click="handleSubmit"
              variant="primary"
              :disabled="loading || isDisableSubmit"
            >
              <b-spinner v-if="loading" small type="grow"></b-spinner>
              {{ loading ? 'Loading...' : 'Simpan' }}
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </div>
</template>
